import { AxiosResponse } from "axios";
import { checkForAppUpdates } from "./checkForAppUpdates";

export const compareAppVersion = (response: AxiosResponse<any>) => {
  if (!response || !process.env.VUE_APP_CHECK_APP_VERSION_FROM_API) return;

  const appVersion = process.env.VUE_APP_VERSION;
  if (response.data?._v) {
    if (response.data?._v !== appVersion) {
      checkForAppUpdates();
    }
  }
};
